const lodging = "lodging";
const poi = "poi";
const partnerActivity = "partner_activity";
const articles = "articles";
const availability = "availability";
const collections = "collections";
const narrative = "narrative";

const resourceTypes = {
  availability,
  lodging,
  poi,
  articles,
  partner_activity: partnerActivity,
  collections,
  narrative,
};

export default resourceTypes;



// WEBPACK FOOTER //
// ../server/lib/open-planet/resourceTypes.js